import script from "./QModalWasteAddType.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalWasteAddType.vue?vue&type=script&setup=true&lang=js"

import "./QModalWasteAddType.vue?vue&type=style&index=0&id=ce0c0822&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce0c0822"]])

export default __exports__